import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { map, path, pathOr } from 'ramda';
import { useHistory, useLocation } from 'react-router-dom';

import css from './style.css';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { addToCart } from '../../ducks/user.duck';
import { withViewport } from '../../util/contextHelpers';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import {
  getBookingDay,
  getHourFormattedBookingDate,
  moment,
} from '../../util/dates';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';

const BookingSearchParams = (props) => {
  const {
    numberOfPeople,
    startAt,
    endAt,
  } = props;
  const history = useHistory();
  const location = useLocation();
  const handleGoBackSearch = (e) => {
    e.preventDefault();
    history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, {}, location.search));
  };
  return (
    <div className={css.bookingSearchParamsContainer}>
      <div>
        {/*<NamedLink to={'CartPage'} name="CartPage">*/}
        <div className={css.bookingSearchParamsEdit} onClick={handleGoBackSearch}>
          <FormattedMessage id="CartPage.BookingBreakdownDateEdit"/>
        </div>
        {/*</NamedLink>*/}
        <div className={css.line}>
          <div>
            <div className={css.bookingSearchParamsLabel}>
              <FormattedMessage id="CartPage.BookingBreakdownDate"/>
            </div>
            <div className={css.bookingSearchParamsValue}>
              {getBookingDay(moment(startAt))}
            </div>
          </div>
          <div>
            {numberOfPeople?.numberOfAdults && (
              <div className={css.right}>
                <div className={css.bookingSearchParamsLabel}>
                  <FormattedMessage id="CartPage.participants"/>
                </div>
                <span className={css.bookingSearchParamsValue}>
                  <FormattedMessage id="CartPage.adultCount"
                                    values={{ count: numberOfPeople.numberOfAdults }}/>
                  {numberOfPeople?.numberOfChildren ? (
                    <span>
                      , <FormattedMessage id="CartPage.childrenCount"
                                          values={{ count: numberOfPeople.numberOfChildren }}/>
                    </span>
                  ) : ''}
                </span>
              </div>
            )}
          </div>
        </div>
        {/*<Divider/>*/}
        <div className={css.line}>
          <div>
            <div className={css.bookingSearchParamsLabel}>
              <FormattedMessage id="CartPage.BookingBreakdownStartDate"/>
            </div>
            <div className={css.bookingSearchParamsValue}>
              {getHourFormattedBookingDate(moment(startAt))}
            </div>
          </div>
          <div className={css.right}>
            <div className={css.bookingSearchParamsLabel}>
              <FormattedMessage id="CartPage.BookingBreakdownEndDate"/>
            </div>
            <div className={css.bookingSearchParamsValue}>
              {getHourFormattedBookingDate(moment(endAt))}
            </div>
          </div>
        </div>
        <div className={css.promoText}>
          <FormattedMessage id="CartPage.PromoStepText" />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state.user;
  const addToCart = pathOr([], ['attributes', 'profile', 'publicData', 'addToCart'], currentUser);
  const numberOfPeople = pathOr(null, ['attributes', 'profile', 'privateData', 'cartBookingParams', 'numberOfPeople'], currentUser);
  const startAt = pathOr(null, ['attributes', 'profile', 'privateData', 'cartBookingParams', 'startAt'], currentUser);
  const endAt = pathOr(null, ['attributes', 'profile', 'privateData', 'cartBookingParams', 'endAt'], currentUser);
  const listingsInCart = getListingsById(state, map(id => ({ uuid: id }), addToCart));
  const listingsCovers = map((listing) => path(['images', 0, 'attributes', 'variants', 'landscape-crop', 'url'], listing), listingsInCart);

  return {
    currentUser,
    scrollingDisabled: isScrollingDisabled(state),
    listingsCovers,
    addToCart,
    numberOfPeople,
    startAt,
    endAt,
  };
};

const mapDispatchToProps = dispatch => ({});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withViewport,
  injectIntl,
)(BookingSearchParams);
